import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { MeState } from './me.state';
import { MeActions } from './me.actions';
import { SimpleUser } from 'app/models';

const initialState: MeState = {
  profile: {
    informations: null,
    loading: false,
  },
  follows: {
    followers: {
      loaded: false,
      loading: false,
      users: {
        data: [],
        meta: null,
      },
    },
    followings: {
      loaded: false,
      loading: false,
      users: {
        data: [],
        meta: null,
      },
    },
  },
  equipments: {
    equipments: [],
  },
  settings: null,
};

export const MeReducer: ActionReducer<
  MeState,
  Action<string>
> = createReducer<MeState>(
  initialState,
  on(MeActions.getProfile, (state): MeState => {
    return {
      ...state,
      profile: {
        informations: state.profile.informations,
        loading: true,
      },
    };
  }),
  on(MeActions.setSettings, (state, { settings }): MeState => {
    return {
      ...state,
      settings,
    };
  }),
  on(MeActions.getSettings, (state): MeState => {
    return {
      ...state,
    };
  }),
  on(MeActions.setProfile, (state, { user }): MeState => {
    return {
      ...state,
      profile: {
        informations: user,
        loading: false,
      },
    };
  }),
  on(MeActions.getFollowers, (state): MeState => {
    return {
      ...state,
      follows: {
        followers: {
          users: state.follows.followers.users,
          loaded: state.follows.followers.loaded,
          loading: true,
        },
        followings: state.follows.followings,
      },
    };
  }),
  on(MeActions.setFollowers, (state, { followers }): MeState => {
    return {
      ...state,
      follows: {
        followers: {
          users: {
            data: [...state.follows.followers.users.data, ...followers.data],
            meta: followers.meta
              ? followers.meta
              : state.follows.followers.users.meta,
          },
          loaded: followers.meta.current_page >= followers.meta.last_page,
          loading: false,
        },
        followings: state.follows.followings,
      },
    };
  }),
  on(MeActions.getFollowings, (state): MeState => {
    return {
      ...state,
      follows: {
        followers: state.follows.followers,
        followings: {
          users: state.follows.followings.users,
          loaded: state.follows.followings.loaded,
          loading: true,
        },
      },
    };
  }),
  on(MeActions.setFollowings, (state, { followings }): MeState => {
    return {
      ...state,
      follows: {
        followers: state.follows.followers,
        followings: {
          users: {
            data: [...state.follows.followings.users.data, ...followings.data],
            meta: followings.meta
              ? followings.meta
              : state.follows.followings.users.meta,
          },
          loaded: followings.meta.current_page >= followings.meta.last_page,
          loading: false,
        },
      },
    };
  }),
  on(MeActions.addFollowing, (state, { user }): MeState => {
    return {
      ...state,
      profile: {
        informations: {
          ...state.profile.informations,
          followings_count: state.profile.informations.followings_count + 1,
        },
        loading: state.profile.loading,
      },
      follows: {
        ...state.follows,
        followings: {
          ...state.follows.followings,
          users: {
            ...state.follows.followings.users,
            data: [user, ...state.follows.followings.users.data],
          },
        },
      },
    };
  }),
  on(MeActions.removeFollowing, (state, { userId }): MeState => {
    return {
      ...state,
      profile: {
        informations: {
          ...state.profile.informations,
          followings_count: state.profile.informations.followings_count - 1,
        },
        loading: state.profile.loading,
      },
      follows: {
        ...state.follows,
        followings: {
          ...state.follows.followings,
          users: {
            ...state.follows.followings.users,
            data: state.follows.followings.users.data.filter(
              (user: SimpleUser) => user.id !== userId
            ),
          },
        },
      },
    };
  }),
  on(MeActions.getEquipments, (state): MeState => {
    return {
      ...state,
      follows: {
        followers: state.follows.followers,
        followings: {
          users: state.follows.followings.users,
          loaded: state.follows.followings.loaded,
          loading: true,
        },
      },
    };
  }),
  on(MeActions.setEquipments, (state, { equipments }): MeState => {
    return {
      ...state,
      equipments: {
        equipments,
      },
    };
  }),
  on(MeActions.getCurrency, (state, { currency }): MeState => {
    return {
      ...state,
    };
  }),
  on(MeActions.setCurrency, (state, { currency }): MeState => {
    return {
      ...state,
      settings: {
        ...state.settings,
        currency: currency,
      },
    };
  }),
  on(MeActions.clear, (): MeState => {
    localStorage.removeItem('settings');
    return initialState;
  })
);
